import { render, staticRenderFns } from "./FactionTreeMiniPanel.vue?vue&type=template&id=126ff6df&"
import script from "./FactionTreeMiniPanel.vue?vue&type=script&lang=js&"
export * from "./FactionTreeMiniPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports